import React from 'react';
import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';
import Drawer from '@nubank/nuds-web/components/Drawer/Drawer';

import { ProspectTypeShape } from 'utils/prospectTypes';

import ProspectRegistrationDrawerFormLoading from './ProspectRegistrationDrawerFormLoading';

const AsyncProspectRegistrationDrawerForm = dynamic(import('./ProspectRegistrationDrawerForm'), {
  ssr: false,
  loading: ProspectRegistrationDrawerFormLoading,
});

function ProspectRegistrationDrawer(props) {
  const {
    open,
    onClose,
    prospectType,
    id,
  } = props;

  return (
    <Drawer id={id} direction="bottom" open={open} onClose={onClose}>
      {({
        DrawerHeader,
        DrawerCloseButton,
        DrawerContent,

      }) => (
        <DrawerContent>
          <DrawerHeader>
            <DrawerCloseButton onClick={onClose} />
          </DrawerHeader>
          {open && <AsyncProspectRegistrationDrawerForm prospectType={prospectType} />}
        </DrawerContent>
      )}
    </Drawer>
  );
}

ProspectRegistrationDrawer.propTypes = {
  id: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  prospectType: ProspectTypeShape.isRequired,
};

export default ProspectRegistrationDrawer;
